import { defaultPersonaList } from "util/testpersonas";
import { modDashboardDemoData } from "../../moddashboard/__demos__/moddashboard-demo.data";
import { makeAssetUrl } from "util/util";

const demoAdmin = defaultPersonaList[0];
const demoEditor = defaultPersonaList[2];
const demoThread = modDashboardDemoData.modulePublicQuestion.thread1;

export const demoChannel0 = {
    channel0: {
        from: demoAdmin.key,
        isDefault: true,
        key: "channel0",
        name: "Default Channel",
        photoUrl: makeAssetUrl("/faces/robo.jpeg"),
        email: "channel0@demo.com"
    },
};

export const demoChannel1 = {
    channel1: {
        from: demoAdmin.key,
        isDefault: false,
        key: "channel1",
        name: "Channel 1",
        photoUrl: makeAssetUrl("/faces/robo.jpeg"),
    },
};

export const demoChannel2 = {
    channel2: {
        from: demoAdmin.key,
        isDefault: false,
        key: "channel2",
        name: "Channel 2",
        photoUrl: makeAssetUrl("/faces/face1.jpeg"),
    },
};

export const demoChannel3 = {
    channel3: {
        from: demoAdmin.key,
        isDefault: false,
        key: "channel3",
        name: "Channel 3",
        photoUrl: makeAssetUrl("/faces/face2.jpeg"),
    },
};

export const demoChannel4 = {
    channel4: {
        from: demoAdmin.key,
        isDefault: false,
        key: "channel4",
        name: "Channel 4",
        photoUrl: makeAssetUrl("/faces/face3.jpeg"),
    },
};

export const demoAdminEmails = ["a@b.com", "c@d.com", "test@test.com"];

export const demoChannelMembers = {
    [demoChannel0.channel0.key]: { memberEmails: [demoAdminEmails[0], demoAdminEmails[1]] },
    [demoChannel1.channel1.key]: { memberEmails: [] as string[] },
    [demoChannel2.channel2.key]: { memberEmails: [demoAdminEmails[1], demoAdminEmails[2]] },
};

export const channelDemoData1 = {
    modulePublic: {
        channel: {
            all: {
                ...demoChannel0,
                ...demoChannel2,
                ...demoChannel3,
                ...demoChannel4,
            },
            "instanceToChannel": {},
        },
    },
    serverCall: {
        channel: {
            getUserChannels: () => [demoChannel2.channel2.key, demoChannel4.channel4.key],
            assignContentToChannel: () => {},
            reassignContentToChannel: () => {},
        },
    },
};

export const channelDemoData2 = {
    modulePublic: { ...channelDemoData1.modulePublic },
    serverCall: {
        channel: {
            getUserChannels: () => [],
            assignContentToChannel: () => {},
            reassignContentToChannel: () => {},
        },
    },
};

export const channelDemoData3 = {
    modulePublic: {
        channel: {
            all: {
                ...demoChannel1,
            },
            "instanceToChannel": {
                "question/test": {
                    [demoChannel1.channel1.key]: {
                        channelKey: demoChannel1.channel1.key,
                        from: demoEditor.key,
                        instanceKey: "test",
                        structureKey: "question",
                        time: 1000,
                    },
                },
            },
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

export const channelDemoData4 = {
    modulePublic: {
        channel: {
            all: {
                ...demoChannel0,
            },
            "instanceToChannel": {},
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

export const channelDemoData5 = {
    modulePublic: {
        channel: {
            all: {
                ...demoChannel1,
                ...demoChannel2,
                ...demoChannel3,
            },
            "instanceToChannel": {},
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

export const channelDemoData6 = {
    modulePublic: {
        channel: {
            all: {
                ...demoChannel1,
            },
            "instanceToChannel": {},
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

export const channelDemoData7 = {
    modulePublic: {
        channel: {
            all: {
                ...channelDemoData1.modulePublic.channel.all,
            },
            instanceToChannel: {
                "question/test": {
                    [demoChannel2.channel2.key]: {
                        key: demoChannel2.channel2.key,
                        concatenatedKey: "question/" + demoThread.key,
                        channelKey: demoChannel2.channel2.key,
                        from: demoEditor.key,
                        instanceKey: "test",
                        structureKey: "question",
                        time: 1000,
                    },
                },
            },
            channelToInstance: {
                [demoChannel2.channel2.key + "/question"]: {
                    [demoThread.key]: {
                        ...demoChannel2,
                        channelKey: demoChannel2.channel2.key,
                        concatenatedKey: "question/" + demoThread.key,
                        instanceKey: demoThread.key,
                        key: demoThread.key,
                        structureKey: "question",
                    },
                },
            },
        },
    },
    serverCall: {
        ...channelDemoData1.serverCall,
    },
};

export const channelManagementDemoData = {
    channelMembers: demoChannelMembers,
    modulePublic: {
        channel: {
            all: {
                ...demoChannel0,
                ...demoChannel1,
                ...demoChannel2,
            },
            instanceToChannel: { ...channelDemoData7.modulePublic.channel.instanceToChannel },
            channelToInstance: { ...channelDemoData7.modulePublic.channel.channelToInstance },
        },
    },
    serverCall: {
        admin: {
            getAdminUsers: () =>
                Promise.resolve([
                    { key: "admin0", roles: ["Moderator"], email: demoAdminEmails[0] },
                    { key: "admin1", roles: ["Moderator"], email: demoAdminEmails[1] },
                    { key: "admin2", roles: ["Moderator"], email: demoAdminEmails[2] },
                ]),
        },
        channel: {
            getChannelMembers: ({ datastore, channelKey }) => {
                const channelMembers = datastore.getSessionData(["channelMembers"]);
                return Promise.resolve(channelMembers[channelKey]);
            },
            addMembersByEmails: ({ emails, channelKey, datastore }) => {
                const channelMembers = datastore.getSessionData(["channelMembers"]);
                const existingEmails = channelMembers[channelKey]?.memberEmails ?? [];
                const combinedEmails = [...existingEmails, ...emails];
                const updatedEmails: string[] = [...new Set(combinedEmails)];
                datastore.setSessionData(["channelMembers"], {
                    ...channelMembers,
                    [channelKey]: { memberEmails: updatedEmails },
                });
                return Promise.resolve();
            },
            removeMemberFromChannel: ({ datastore, email, channelKey }) => {
                const channelMembers = datastore.getSessionData(["channelMembers"]);
                const updatedMemberList = channelMembers[channelKey].memberEmails.filter((user) => user !== email);
                channelMembers[channelKey].memberEmails = updatedMemberList;
                datastore.setSessionData(["channelMembers"], channelMembers);
                return Promise.resolve();
            },
            deleteChannel: ({ channelKey }) => {
                return Promise.resolve();
            }
        },
    },
};

function mockGetChannelFakeUser() {
    return demoChannel0.channel0;
};

export const channelModDashboardDemoData = {
    modulePublic: {
        channel: {
            all: {
                ...demoChannel0,
            },
            channelToInstance: {
                [demoChannel0.channel0.key + "/question"]: {
                    [demoThread.key]: {
                        ...demoChannel0,
                        channelKey: demoChannel0.channel0.key,
                        concatenatedKey: "question/" + demoThread.key,
                        instanceKey: demoThread.key,
                        key: demoThread.key,
                        structureKey: "question",
                    },
                },
            },
            instanceToChannel: {
                ["question/" + demoThread.key]: {
                    [demoChannel0.channel0.key]: {
                        ...demoChannel0,
                        channelKey: demoChannel0.channel0.key,
                        concatenatedKey: "question/" + demoThread.key,
                        instanceKey: demoThread.key,
                        key: demoChannel0.channel0.key,
                        structureKey: "question",
                    },
                },
            },
        },
    },
    serverCalls: {
        channel: {
            getChannelFakeUser: mockGetChannelFakeUser,
            postCommentAsChannelUser: () => {},
        },
    },
};
